/**
 * Collection of alias tokens for palette colors. Maps base color tokens to semantic names for
 * meaningful representation.
 */ const colorAliases = {
    primary: 'green',
    accent: 'blue',
    neutral: 'gray',
    info: 'blue',
    positive: 'green',
    warning: 'amber',
    negative: 'red',
    ad: 'yellow',
    promote: 'purple',
    attention: 'red'
};

export { colorAliases };
//# sourceMappingURL=colors.js.map
